var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsGraphSocialBehavior(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.26 24.172c-5.986 5.938-6.025 15.604-.087 21.59l.087.087 18.25 18.104a7.703 7.703 0 0 0 10.85 0l10.916-10.828a7.703 7.703 0 0 0 0-10.938L38.114 24.172c-6.049-6-15.805-6-21.854 0z",
    fill: "#FFAB61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.74 24.172c5.986 5.938 6.025 15.604.087 21.59l-.087.087-18.25 18.104a7.703 7.703 0 0 1-10.85 0L23.724 53.125a7.703 7.703 0 0 1 0-10.938l18.162-18.015c6.049-6 15.805-6 21.854 0z",
    fill: "#FFDBBB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.28 24.482a5.089 5.089 0 0 0 0 7.226l3.642 3.613c2.017 2 5.268 2 7.285 0a5.089 5.089 0 0 0 0-7.226l-3.642-3.613c-2.017-2-5.269-2-7.285 0zM43.791 43.922l-9.145 9.07a7.633 7.633 0 0 0 0 10.84l.943.935a6.419 6.419 0 0 0 9.041 0l10.918-10.83a6.419 6.419 0 0 0 0-9.114l-.908-.9a7.703 7.703 0 0 0-10.849 0z",
    fill: "#FFAB61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGraphSocialBehavior);
export default __webpack_public_path__ + "static/media/icons_graph_social_behavior.3c90cc17f29a3a59859cadf29d77750e.svg";
export { ForwardRef as ReactComponent };